import React, { useState } from 'react';


export default function Textforms(props) {
  const handleUpClick=()=>{
    console.log("upper was click"+text)
    let newtext=text.toUpperCase();
    setText(newtext)
    props.showAlert("converted to UPPERCASE!","success");
  }
  const handleLoClick=()=>{
    console.log("lower was click"+text)
    let newtext=text.toLowerCase();
    setText(newtext)
    props.showAlert("converted to LOWERCASE!","success");
  }
  const handleClearClick=()=>{
    console.log("Clear was click"+text)
    let newtext=" ";
    setText(newtext)
    props.showAlert("Clear all Text","success");
  }
  const handleOnChange=(event)=>{
    console.log("upper was click");
   
    setText(event.target.value);

  }
  const [text, setText] = useState('Enter text here');
  //text="new text";//wrong way to change the state
  //setText("new text");//correct way to change the state
  const handleCopy=()=>{
    console.log("copied");
    // var text=document.getElementById("myBox");
    //  text.select();
     //navigator.clipboard.writeText(text.value);
     navigator.clipboard.writeText(text);
     document.getSelection().removeAllRanges();
    props.showAlert("Copied the data!","success");
  }
  const handleExtraspacesClick = ()=>{
    let newtext=text.split(/[ ]+/);
    setText(newtext.join(" "))
    props.showAlert("Remove All the ExtraSpaces","success");
  }
  return (
    <>
    <div className='container'  style={{color:props.mode==='dark'?'white':'#042743'}}>
      <h2 className='mb-4'>
        {props.heading}
      </h2>

      <div className="mb-3">
        <textarea
          className="form-control"value={text} onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'#13466e':'white' ,color:props.mode==='dark'?'white':'#042743'}}
          id="myBox"
          rows="8"
        ></textarea>
      </div>
      <button disabled={text.length===0} type="button"  className="btn btn-dark mx-2 my-2"onClick={handleUpClick}>Convert to uppercase</button>
      <button disabled={text.length===0} type="button" className="btn btn-dark mx-2 my-2"onClick={handleLoClick}>Convert to Lowercase</button>
      <button disabled={text.length===0} type="button" className="btn btn-dark mx-2 my-2" onClick={handleClearClick}>Clear </button>
      <button disabled={text.length===0} type="button" className="btn btn-dark mx-2 my-2" onClick={handleCopy}>Copy Text </button>
      
      <button disabled={text.length===0} type="button" className="btn btn-dark mx-2 my-2" onClick={handleExtraspacesClick}>Remove Extra Spaces </button>
      
     
     
    </div>

    <div className="container my-3" style={{color:props.mode==='dark'?'white':'#042743'}}>
      <h1>your text summary</h1>
      <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length } words and {text.length} characters</p>
      <p>{text.split(" ").filter((element)=>{return element.length!==0}).length *.008} Minutes read</p>
      <h2>Preview</h2>
      <p>{text.length>0?text:"Nothing to preview"}</p>
    </div>
    </>
  );
}
